import ApiService from '@/services/api.service'
import { orderBy } from 'lodash'

// action types
export const GET_PROPERTIES = 'getProperties'
export const GET_FILTERED_PROPERTIES = 'getFilteredProperties'
export const GET_FEATURED_PROPERTIES = 'getFeaturedProperties'
export const GET_PROMOTED_PROPERTIES = 'getPromotedProperties'
export const GET_PROPERTY = 'getProperty'

// mutation types
export const SET_PROPERTIES = 'setProperties'
export const SET_FILTERED_PROPERTIES = 'setFilteredProperties'
export const SET_FEATURED_PROPERTIES = 'setFeaturedProperties'
export const SET_PROMOTED_PROPERTIES = 'setPromotedProperties'
export const SET_PROPERTY = 'setProperty'
export const SET_ERROR = 'setError'

const state = {
  errors: null,
  properties: [],
  featuredProperties: [],
  promotedProperties: [],
  currentProperty: {
    images: [],
    rooms: [],
    amenities: [],
    city: null,
  },
  filteredProperties: [],
}

const getters = {
  properties: (s) => s.properties,
  featuredProperties: (s) => s.featuredProperties,
  promotedProperties: (s) => s.promotedProperties,
  currentProperty: (s) => s.currentProperty,
  filteredProperties: (s) => s.filteredProperties,
}

const actions = {
  [GET_PROPERTIES](context, payload) {
    return new Promise((resolve) => {
      // LISTA: GET /get-data/properties?...
      ApiService.get('/get-data/properties', '', payload)
        .then(({ data }) => {
          context.commit(SET_PROPERTIES, orderBy(data.data || [], 'price', 'desc'))
          resolve(data)
        })
        .catch((err) => {
          const e = err?.response?.data?.errors || err?.response?.data || err
          context.commit(SET_ERROR, e)
        })
    })
  },

  [GET_FILTERED_PROPERTIES](context, payload) {
    // payload: { attribute: 'type' | 'status' | '...' , value: 'promo' | ... , ...ostali query parametri }
    return new Promise((resolve) => {
      ApiService.get('/get-data/properties', '', payload)
        .then(({ data }) => {
          const list = data.data || []
          const filtered = list.filter((p) => p[payload.attribute] === payload.value)
          context.commit(SET_FILTERED_PROPERTIES, orderBy(filtered, 'price', 'desc'))
          resolve(data)
        })
        .catch((err) => {
          const e = err?.response?.data?.errors || err?.response?.data || err
          context.commit(SET_ERROR, e)
        })
    })
  },

  [GET_FEATURED_PROPERTIES](context, payload) {
    return new Promise((resolve) => {
      ApiService.get('/get-data/properties', '', payload)
        .then(({ data }) => {
          // featured je boolean
          const featured = (data.data || []).filter((p) => p.featured === true)
          // ako 'featured_position' može biti null/undefined, Lodash orderBy će ih staviti na kraj
          context.commit(SET_FEATURED_PROPERTIES, orderBy(featured, 'featured_position', 'asc'))
          resolve(data)
        })
        .catch((err) => {
          const e = err?.response?.data?.errors || err?.response?.data || err
          context.commit(SET_ERROR, e)
        })
    })
  },

  [GET_PROMOTED_PROPERTIES](context, payload) {
    return new Promise((resolve) => {
      ApiService.get('/get-data/properties', '', payload)
        .then(({ data }) => {
          const promoted = (data.data || []).filter((p) => p.status === 'promo')
          context.commit(SET_PROMOTED_PROPERTIES, promoted)
          resolve(data)
        })
        .catch((err) => {
          const e = err?.response?.data?.errors || err?.response?.data || err
          context.commit(SET_ERROR, e)
        })
    })
  },

  [GET_PROPERTY](context, payload) {
    return new Promise((resolve) => {
      // DETALJ: GET /get-data/properties/{id-or-slug}?with=...&only=...
      const data = payload || {}
      const identifier = data.id || data.slug || ''
      const { id: _id, slug: _slug, ...params } = data

      ApiService.get('/get-data/properties', identifier, params)
        .then(({ data }) => {
          context.commit(SET_PROPERTY, data.data)
          resolve(data)
        })
        .catch((err) => {
          const e = err?.response?.data?.errors || err?.response?.data || err
          context.commit(SET_ERROR, e)
        })
    })
  },
}

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error
  },
  [SET_PROPERTIES](state, properties) {
    state.properties = properties
    state.errors = {}
  },
  [SET_FILTERED_PROPERTIES](state, properties) {
    state.filteredProperties = properties
    state.errors = {}
  },
  [SET_FEATURED_PROPERTIES](state, properties) {
    state.featuredProperties = properties
    state.errors = {}
  },
  [SET_PROMOTED_PROPERTIES](state, properties) {
    state.promotedProperties = properties
    state.errors = {}
  },
  [SET_PROPERTY](state, property) {
    state.currentProperty = property
    state.errors = {}
  },
}

export default {
  state,
  actions,
  mutations,
  getters,
}
